import { api } from 'api/v1/api';

export type SupportMessagePayload = {
  subject: string;
  body: string;
};

export const sendSupportMessage = async (
  payload: SupportMessagePayload,
): Promise<{ ok: boolean; email_sent: boolean }> =>
  (await api.post('/support/messages/', payload)).data;
